<!--
 * @Description: 合并线索 谷仓/云途市场营销  云途线索管理
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-06-26 10:03:42
 * @LastEditors: cxh
-->
<template>
  <div style="display: inline-block; margin-right: 10px">
    <a-button @click="showModal">合并</a-button>
    <CosModal
      v-model:visible="visible"
      title="线索合并后数据将不能恢复，请谨慎操作！"
      class="clueMerge"
      width="750px"
      @ok="handleSubmit"
      :confirmLoading="loading"
    >
      <a-alert
        message="合并后，只保留选择的线索，删除其他的线索；原线索中不重复的联系人均会合并到新线索下。"
        type="warning"
        show-icon
      />
      <ul class="list">
        <li v-for="(item, index) in data" :key="index">
          <div class="flex1 content">
            <p>待合并线索：</p>
            <p class="name" :title="item.customerName">{{ item.customerName }}</p>
          </div>
          <div class="flex1 content">
            <p>ID：</p>
            <p class="name">{{ item.clueId }}</p>
          </div>
        </li>
      </ul>
      <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
        <a-form-item name="targetClueId" label="合并到线索" :rules="[{ required: true, message: '请选择' }]">
          <a-select v-model:value="editForm.targetClueId" placeholder="请选择">
            <a-select-option v-for="item in data" :key="item.clueId" :value="item.clueId">{{
              item.customerName
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </CosModal>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { clueMerge as zbuClueMerge } from '@/api/marketing/marketingManage'
import { clueMerge as lbuClueMerge } from '@/api/yuntuSales/clueManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'
const props = defineProps({
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String, // 描述
    default: 'cos_zbu'
  }
})
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
// 函数枚举对象
const clueMerge = {
  cos_zbu: zbuClueMerge,
  cos_lbu: lbuClueMerge
}
const emit = defineEmits(['success'])

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { targetClueId } = editForm.value
    const originalIdList: any[] = []
    props.data.forEach((item) => {
      if (item.clueId !== targetClueId) {
        originalIdList.push(item.clueId)
      }
    })
    const p = {
      targetClueId,
      originalIdList
    }
    clueMerge[props.appId](p)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('合并成功')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 2) {
    DcMessage.error('请选择两条以上数据进行合并操作！')
    return
  }
  visible.value = true
  editForm.value = {}
}
</script>
<style lang="scss" scoped>
.list {
  margin: 20px 0;
  li {
    display: flex;
    margin-bottom: 9px;
    .content {
      display: flex;
      align-items: center;
    }
  }
  .name {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 210px;
    padding: 0;
  }
}
.flex1 {
  flex: 1;
}
</style>
